export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center w-full overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/60"></div>
      <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
      <div className="absolute bottom-0 left-20 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-sm font-medium mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              今日热门
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              51吃瓜爆料网
              <span className="block text-primary-500 text-xl md:text-2xl lg:text-3xl mt-2 font-sans font-bold">
                全网最新娱乐八卦每日爆料平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-sans mb-4">
              娱乐圈八卦、网红黑料、每日爆料一网打尽
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-xl lg:max-w-none">
              51吃瓜爆料网是国内领先的娱乐八卦资讯平台，每日更新全网最新吃瓜爆料内容。
              覆盖娱乐圈明星八卦、网红黑料合集、综艺内幕揭秘、直播带货翻车、选秀节目黑幕等热门话题。
              编辑团队7×24小时全天候监控全网动态，确保今日热门爆料事件第一时间呈现。
              无论是最新恋情曝光、明星塌房、税务风波还是饭圈乱象，这里都有最全的每日爆料汇总。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-primary-100">
                  <i className="ri-flashlight-line text-lg text-primary-600"></i>
                </div>
                <div className="text-left">
                  <div className="text-base md:text-lg font-bold text-foreground-900">200+</div>
                  <div className="text-xs text-foreground-500">每日更新爆料</div>
                </div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-accent-100">
                  <i className="ri-user-star-line text-lg text-accent-600"></i>
                </div>
                <div className="text-left">
                  <div className="text-base md:text-lg font-bold text-foreground-900">500+</div>
                  <div className="text-xs text-foreground-500">覆盖网红明星</div>
                </div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-xl bg-secondary-100">
                  <i className="ri-group-line text-lg text-secondary-700"></i>
                </div>
                <div className="text-left">
                  <div className="text-base md:text-lg font-bold text-foreground-900">千万+</div>
                  <div className="text-xs text-foreground-500">吃瓜群众在线</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => handleClick(e, '#carousel')}
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all whitespace-nowrap cursor-pointer text-center"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#app"
                onClick={(e) => handleClick(e, '#app')}
                className="w-full sm:w-auto px-8 py-3.5 text-base font-medium text-foreground-700 bg-background-100 hover:bg-background-200 border border-background-300 rounded-full transition-all whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-download-line mr-2"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-3xl blur-xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-200 shadow-sm">
                <img
                  src="https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20collage%20with%20microphone%20spotlight%20paparazzi%20camera%20flashes%20and%20newspaper%20headlines%2C%20warm%20red%20and%20amber%20theatrical%20lighting%2C%20backstage%20atmosphere%2C%20bold%20tabloid%20aesthetic%2C%20cinematic%20composition%2C%20dramatic%20shadows%20and%20highlights&width=1200&height=900&seq=hero-main&orientation=portrait"
                  alt="51吃瓜爆料网 - 全网最新娱乐八卦每日爆料"
                  className="w-full h-auto object-cover"
                  width="600"
                  height="450"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-background-50 rounded-xl px-4 py-3 border border-background-200 shadow-sm">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center">
                    <i className="ri-fire-line text-white text-sm"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">今日热度</div>
                    <div className="text-sm font-bold text-foreground-900">2,035万+</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}